import { useTranslation } from "react-i18next";
import {Col, Empty, Row, Spin, TableColumnsType} from "antd";
import TableWithTotals from "../../../../../../../components/table-with-totals/TableWithTotals";
import {
  exportCourseAssignTeacher,
  exportCoursesByFormat,
  exportMultimaterialsByType,
  exportNumberSCORMxAPI,
  exportReferenceSourceByType,
  exportSequenceByAvailableStatus,
  exportSequenceByDepartment,
  exportTestByType,
  exportUnitByCourse,
} from "../../../../../../../service/statistical-report";
import {staticReportStore} from "../../../../../../../stores/stores";
import {BarStackedChartProps, PieChart,} from "../../../../../../../types/static-report";
import StatisticalReportCard from "../../../StatisticalReportCard";
import {createTableData} from "../../tableConvertData";
import {handleExportReport} from "../../../../../../../utils/staticReport";
import dayjs from "dayjs";

type Props = {
  loading: Record<string, boolean>;
  coursesByFormatList: PieChart[];
  sequenceByAvailableStatus: PieChart[];
  sequenceByDepartment: PieChart[];
  scormAndXAPI: PieChart[];
  multiMaterialsByType: PieChart[];
  unitByCourse: BarStackedChartProps[];
  testByType: PieChart[];
  referenceSourceByType: PieChart[];
  courseAssignTeacher: BarStackedChartProps[];
};

const ResourcesTableTab = (props: Props) => {
  const { t } = useTranslation();
  const {
    loading,
    coursesByFormatList,
    sequenceByAvailableStatus,
    sequenceByDepartment,
    scormAndXAPI,
    multiMaterialsByType,
    testByType,
    referenceSourceByType,
    unitByCourse,
    courseAssignTeacher,
  } = props;
  const {filterValues} = staticReportStore();

  const columns: TableColumnsType<any> = [
    {
      title: t("Hình thức", "Hình thức"),
      dataIndex: "criteria",
      key: "criteria",
      render: (text: any) => <div className="font-weight-5">{text}</div>,
    },
    {title: t("Số lượng", "Số lượng"), dataIndex: "count", key: "count"},
  ];

  const sequenceByDepartmentColumns: TableColumnsType<any> = [
    {
      title: "Khoa",
      dataIndex: "criteria",
      key: "criteria",
      render: (text: any) => <div className="font-weight-5">{text}</div>,
    },
    {
      title: t("Số lượng bài giảng", "Số lượng bài giảng"),
      dataIndex: "count",
      key: "count",
    },
  ];

  const statisticsLearningResourcesColumns: TableColumnsType<any> = [
    {
      title: t("Thông tin", "Thông tin"),
      dataIndex: "criteria",
      key: "criteria",
      render: (text: any) => <div className="font-weight-5">{text}</div>,
    },
    {title: t("Số lượng", "Số lượng"), dataIndex: "count", key: "count"},
  ];

  const exportPayload = {
    from: dayjs(filterValues.dateFrom).toISOString(),
    to: dayjs(filterValues.dateTo).toISOString(),
    courseLevelIds: filterValues?.courseLevelIds,
    industryGroupIds: filterValues?.industryGroupIds,
    courseIds: filterValues?.courseIds,
    timeUnit: filterValues.timeUnit,
    universityIds: filterValues?.universityIds,
  };

  return (
    <div>
      <div className="chart-title">{t("Thống kê số lượng khoá học", "Thống kê số lượng khoá học")}</div>
      <Row gutter={{xs: 8, sm: 8, md: 16, lg: 16}}>
        <Col sm={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Số lượng khoá học theo phân công", "Số lượng khoá học theo phân công")}
            content={
              <Spin spinning={loading.courseAssignTeacher}>
                {courseAssignTeacher.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={createTableData(courseAssignTeacher).dataSource}
                    columns={[
                      {
                        title: t("Ngày tải lên khoá học", "Ngày tải lên khoá học"),
                        dataIndex: "name",
                        key: "name",
                      },
                      ...createTableData(courseAssignTeacher).columns,
                    ]}
                    keyColumn="criteria"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              courseAssignTeacher.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportCourseAssignTeacher, t("Số lượng khoá học theo phân công", "Số lượng khoá học theo phân công"),
                        "excel",
                        exportPayload
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportCourseAssignTeacher, t("Số lượng khoá học theo phân công", "Số lượng khoá học theo phân công"),
                        "pdf",
                        exportPayload
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
        <Col sm={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Số lượng khoá học theo hình thức xuất bản", "Số lượng khoá học theo hình thức xuất bản")}
            content={
              <Spin spinning={loading.coursesByFormatList}>
                {coursesByFormatList.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={coursesByFormatList}
                    columns={columns}
                    keyColumn="type"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              courseAssignTeacher.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportCoursesByFormat, t("Số lượng khoá học theo hình thức xuất bản", "Số lượng khoá học theo hình thức xuất bản"),
                        "excel",
                        exportPayload
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportCoursesByFormat, t("Số lượng khoá học theo hình thức xuất bản", "Số lượng khoá học theo hình thức xuất bản"),
                        "pdf",
                        exportPayload
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
      </Row>

      <div className="chart-title">{t("Thống kê số lượng bài giảng", "Thống kê số lượng bài giảng")}</div>
      <Row gutter={{xs: 8, sm: 8, md: 16, lg: 16}}>
        <Col sm={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Số lượng bài giảng theo khoa", "Số lượng bài giảng theo khoa")}
            content={
              <Spin spinning={loading.sequenceByDepartment}>
                {sequenceByDepartment.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={sequenceByDepartment}
                    columns={sequenceByDepartmentColumns}
                    keyColumn="type"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              sequenceByDepartment.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportSequenceByDepartment, t("Số lượng bài giảng theo khoa", "Số lượng bài giảng theo khoa"),
                        "excel",
                        exportPayload
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportSequenceByDepartment, t("Số lượng bài giảng theo khoa", "Số lượng bài giảng theo khoa"),
                        "pdf",
                        exportPayload
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
        <Col sm={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Số lượng bài giảng theo trạng thái xuất bản", "Số lượng bài giảng theo trạng thái xuất bản")}
            content={
              <Spin spinning={loading.sequenceByAvailableStatus}>
                {sequenceByAvailableStatus.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={sequenceByAvailableStatus}
                    columns={columns}
                    keyColumn="type"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              sequenceByAvailableStatus.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportSequenceByAvailableStatus, t("Số lượng bài giảng theo trạng thái xuất bản", "Số lượng bài giảng theo trạng thái xuất bản"),
                        "excel",
                        exportPayload
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportSequenceByAvailableStatus, t("Số lượng bài giảng theo trạng thái xuất bản", "Số lượng bài giảng theo trạng thái xuất bản"),
                        "pdf",
                        exportPayload
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
      </Row>

      <div className="chart-title">{t("Thống kê số lượng học liệu", "Thống kê số lượng học liệu")}</div>
      <Row gutter={{xs: 8, sm: 8, md: 16, lg: 16}}>
        <Col xl={{span: 6}} lg={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Số lượng bài kiểm tra theo loại", "Số lượng bài kiểm tra theo loại")}
            content={
              <Spin spinning={loading.testByType}>
                {testByType.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={testByType}
                    columns={statisticsLearningResourcesColumns}
                    keyColumn="type"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              testByType.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportTestByType, t("Số lượng bài kiểm tra theo loại", "Số lượng bài kiểm tra theo loại"),
                        "excel",
                        exportPayload
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportTestByType, t("Số lượng bài kiểm tra theo loại", "Số lượng bài kiểm tra theo loại"),
                        "pdf",
                        exportPayload
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
        <Col xl={{span: 6}} lg={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Số lượng tài liệu tham khảo theo loại", "Số lượng tài liệu tham khảo theo loại")}
            content={
              <Spin spinning={loading.referenceSourceByType}>
                {referenceSourceByType.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={referenceSourceByType}
                    columns={statisticsLearningResourcesColumns}
                    keyColumn="type"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              referenceSourceByType.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportReferenceSourceByType, t("Số lượng tài liệu tham khảo theo loại", "Số lượng tài liệu tham khảo theo loại"),
                        "excel",
                        exportPayload
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportReferenceSourceByType, t("Số lượng tài liệu tham khảo theo loại", "Số lượng tài liệu tham khảo theo loại"),
                        "pdf",
                        exportPayload
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
        <Col xl={{span: 6}} lg={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Số lượng Scorm & xAPI", "Số lượng Scorm & xAPI")}
            content={
              <Spin spinning={loading.scormAndXAPI}>
                {scormAndXAPI.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={scormAndXAPI}
                    columns={statisticsLearningResourcesColumns}
                    keyColumn="type"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              scormAndXAPI.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportNumberSCORMxAPI, t("Số lượng Scorm & xAPI", "Số lượng Scorm & xAPI"),
                        "excel",
                        exportPayload
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportNumberSCORMxAPI, t("Số lượng Scorm & xAPI", "Số lượng Scorm & xAPI"),
                        "pdf",
                        exportPayload
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
        <Col xl={{span: 6}} lg={{span: 12}} xs={{span: 24}}>
          <StatisticalReportCard
            chartName={t("Số lượng học liệu đa phương tiện theo loại", "Số lượng học liệu đa phương tiện theo loại")}
            content={
              <Spin spinning={loading.multiMaterialsByType}>
                {multiMaterialsByType.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={multiMaterialsByType}
                    columns={statisticsLearningResourcesColumns}
                    keyColumn="type"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={
              multiMaterialsByType.length > 0
                ? [
                  {
                    label: "Excel",
                    action: () =>
                      handleExportReport(exportMultimaterialsByType, t("Số lượng học liệu đa phương tiện theo loại", "Số lượng học liệu đa phương tiện theo loại"),
                        "excel",
                        exportPayload
                      ),
                  },
                  {
                    label: "PDF",
                    action: () =>
                      handleExportReport(exportMultimaterialsByType, t("Số lượng học liệu đa phương tiện theo loại", "Số lượng học liệu đa phương tiện theo loại"),
                        "pdf",
                        exportPayload
                      ),
                  },
                ]
                : []
            }
          />
        </Col>
      </Row>

      <div className="mt-2">
        <StatisticalReportCard
          chartName={t("Số lượng học liệu theo khoá học", "Số lượng học liệu theo khoá học")}
          content={
            <Spin spinning={loading.unitByCourse}>
              {unitByCourse.length > 0 ? (
                <TableWithTotals
                  totalLabel={t("Tổng", "Tổng")}
                  data={createTableData(unitByCourse).dataSource}
                  columns={[
                    {
                      title: t("Tên khoá học", "Tên khoá học"),
                      dataIndex: "name",
                      key: "name",
                    },
                    ...createTableData(unitByCourse).columns,
                    {
                      title: t("Tổng", "Tổng"),
                      dataIndex: "total",
                      key: "total",

                    },
                  ]}
                  keyColumn="criteria"
                  height={275}
                />
              ) : (
                <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
              )}
            </Spin>
          }
          exportOptions={
            unitByCourse.length > 0
              ? [
                {
                  label: "Excel",
                  action: () =>
                    handleExportReport(exportUnitByCourse, t("Số lượng học liệu theo khoá học", "Số lượng học liệu theo khoá học"),
                      "excel",
                      exportPayload
                    ),
                },
                {
                  label: "PDF",
                  action: () =>
                    handleExportReport(exportUnitByCourse, t("Số lượng học liệu theo khoá học", "Số lượng học liệu theo khoá học"),
                      "pdf",
                      exportPayload
                    ),
                },
              ]
              : []
          }
        />
      </div>
    </div>
  );
};

export default ResourcesTableTab;
